import {Component, OnInit} from '@angular/core';
import {HostLocationService} from './host-location.service';

@Component({
    selector: 'smart-root',
    template: '<router-outlet></router-outlet>'
})
export class AppComponent {
    title = 'smartadmin-angular-seed';

    constructor(private hostLocation: HostLocationService) {
        this.hostLocation.handleNavigation();

    }

}
